const OFFER = "Offers";
const CAMPAIGN = "Campaigns";
const AFFILIATE = "Affiliates";
const PROGRAM = "Programs";
const ADVERTISER = "Advertisers";
const AM = "AM";
const BD = "BD";
const GEO = "Geo";
const HOUR = "Hour";
const DEVICE = "Device";
const VERTICAL = "Verticals";

export const devs =
    ['dmytro.miroshnykov', 'vladislav.trofimov', 'timothy.josse','semion.kopachevsky'];
    // [ 'vladislav.trofimov', 'timothy.josse'];
export const sales =
    ['sergionikonorov', 'nancy.volkova'];

export const NAVIGATION_ITEMS = [
    OFFER,
    CAMPAIGN,
    AFFILIATE,
    PROGRAM,
    ADVERTISER,
    AM,
    BD,
    GEO,
    HOUR,
    DEVICE,
    VERTICAL,
];

export const DRILL_DOWNS = [
    "Offer",
    "Program",
    "Campaign",
    "Sub_campaign",
    "Geo",
    "Day",
    "Hour",
    "Isp",
    "Affiliate",
    "Os",
    "Device",
    "Vertical_name",
    "Advertiser",
    "Affiliate_manager",
    "Advertiser_manager",
    "Referer",
    "Tier",
    "Highest_tier",
    "Custom",
    "Img",
    "Kw",
    "Cid",
    "Lid",
    "State"
];

export const COLUMNS = [
    "avg_cost",
    "clicks",
    "conversions",
    "cost",
    "epc",
    "installations",
    "margin",
    "profit",
    "registrations",
    "revenue",
    "sales",
    "sales_ratio",
    "tags",
    "total_paid",
    "uvs_sales_ratio",
    "uvs",
    "reg_tp",
    "last_click_day",
    "last_conversion_day"
];
export const AVAILABLE_OPERATORS=[
    'Contains',
    'Does not contain',
    'Is empty',
    'Is not empty',
    'Is exactly',
    'Greater than',
    'Less than',
    'Equal to',
    'Not equal to'
]
export const ALL_FILTERS =[
    "Offer",
    "Program",
    "Campaign",
    "Sub_campaign",
    "Geo",
    "Hour",
    "Affiliate",
    "Device",
    "Verticals",
    "Advertiser",
    "Affiliate_manager",
    "Advertiser_manager"
]
